import { combineReducers } from '@reduxjs/toolkit';
import adminNotificationSlice from 'store/slices/admin/notifications-slice';
import surveySlice from "store/slices/candidate/survey/survey-slice";
import applyJobHomeSlice from "store/slices/candidate/apply-job/apply-job-home-slice";
import candidateProfileSlice from "store/slices/candidate/candidate-profile-slice";
import candidateNotificationsSlice from "store/slices/candidate/candidate-notifications-slice";
import applyJobQuestionnaireSlice from "store/slices/candidate/apply-job/apply-job-questionnaire.slice";
import applicantProfileSlice from "../employer/applicants/applicant-profile-slice";

const candidateReducer = combineReducers({
    applyJobHome: applyJobHomeSlice.reducer,
    candidateProfile: candidateProfileSlice.reducer,
    survey: surveySlice.reducer,
    candidateNotifications: candidateNotificationsSlice.reducer,
    applyJobQuestionnaire: applyJobQuestionnaireSlice.reducer,
    applicantProfile: applicantProfileSlice.reducer,
});

export { adminNotificationSlice, applyJobHomeSlice, candidateNotificationsSlice, candidateProfileSlice, surveySlice };
export default candidateReducer;

